import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  UniqueBnDev,
  SessionDistribution,
  UniqueBookings,
  UniqueBought,
  TrafficSource
} from './components'
import { AIDrawer } from '../AIAgent'
import { selectRecommendations, selectDrawerOpen, setDrawerOpen, selectAgentEnabled } from '../AIAgent/agentSlice'
import { HiSparkles } from 'react-icons/hi2'

const Main = () => {
  const dispatch = useDispatch();
  const drawerOpen = useSelector(selectDrawerOpen);
  const recommendations = useSelector(selectRecommendations);
  const agentEnabled = useSelector(selectAgentEnabled);

  return (
    // do not remove flex-grow, it is used to fill the remaining space
    <div className="flex-grow" >
      <div className="my-3 p-3 w-full">

        {/* ─── Dashboard cards — now full width ─── */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <UniqueBnDev display={"dashboard"} />
          <SessionDistribution display={"dashboard"} />
          <UniqueBookings />
          <UniqueBought />
          <div className="lg:col-span-2">
            <TrafficSource />
          </div>
        </div>
      </div>

      {/* ─── Floating AI Insights chatbot button (bottom-right) ─── */}
      {agentEnabled && !drawerOpen && (
        <button
          onClick={() => dispatch(setDrawerOpen(true))}
          aria-label="Open AI Insights"
          title="AI Insights"
          className="group fixed bottom-6 right-6 z-[55] flex items-center h-14 rounded-full pl-4 pr-4 hover:pr-5 bg-gradient-to-br from-cyan-500 to-indigo-600 text-white shadow-lg shadow-cyan-500/30 hover:shadow-xl hover:shadow-cyan-500/40 transition-all duration-300"
        >
          <span className="relative flex items-center justify-center shrink-0">
            <HiSparkles className="text-2xl" />
            {recommendations.length > 0 && (
              <span className="absolute -top-3 -right-3 min-w-[20px] h-5 flex items-center justify-center px-1.5 rounded-full bg-rose-500 text-white text-[10px] font-bold shadow-sm ring-2 ring-white">
                {recommendations.length}
              </span>
            )}
          </span>
          <span className="whitespace-nowrap text-sm font-semibold ml-2">
            AI Insights
          </span>
        </button>
      )}

      {/* ─── AI Drawer (overlay, not in grid) ─── */}
      {agentEnabled && (
        <AIDrawer isOpen={drawerOpen} onClose={() => dispatch(setDrawerOpen(false))} />
      )}
    </div>
  );
};

export default Main;
